import { providenceCoreProperty } from "../../property/resource/providence-core-property";
import { ResourceColumn } from "../planner-column";

export const providenceCoreColumn = new ResourceColumn(
  'Providence Cores',
  'stl_limit_break_item_19_cropped.png',
  'providenceCores',
  providenceCoreProperty,
)
